import styled from 'styled-components'

export const HeadingOne = styled.h1`${props => props.$style}`
export const HeadingTwo = styled.h2`${props => props.$style}`
export const HeadingThree = styled.h3`${props => props.$style}`
export const HeadingFour = styled.h4`${props => props.$style}`
export const HeadingFive = styled.h5`${props => props.$style}`
export const HeadingSix = styled.h6`${props => props.$style}`
export const Paragraph = styled.p`${props => props.$style}`
export const Span = styled.span`${props => props.$style}`
export const Label = styled.label`${props => props.$style}`
export const Cite = styled.cite`${props => props.$style}`
export const A = styled.a`${props => props.$style}`